import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { setToken } from '../api/apiUtils';
import { getByUsername } from '../api/userApi';

interface User {
  [key: string]: any;
}

export const fetchAndStoreUser = createAsyncThunk<
  any, // TODO: properly type Return type
  any, // TODO: properly type Argument type
  {
    rejectValue: string;
  }
>('auth/fetchAndStoreUser', async (user, { dispatch, rejectWithValue }) => {
  try {
    setToken(user.access_token);
    const username = user.profile.preferred_username ?? user.profile.name;

    if (!username) {
      return rejectWithValue('Username not found in user profile');
    }

    dispatch(storeUser({ username, isLoading: true }));

    const currentUser = await getByUsername(username);

    dispatch(
      userSignedIn({
        ...(currentUser as object),
        access_token: user.access_token,
      })
    );

    return currentUser;
  } catch (error) {
    if (error instanceof Error) {
      return rejectWithValue(error.message);
    }
    return rejectWithValue('An unknown error occurred');
  }
});

const userSlice = createSlice({
  name: 'auth',
  initialState: null as User | null,
  reducers: {
    storeUser: (state, action: PayloadAction<User>) => {
      return action.payload;
    },
    userSignedIn: (state, action: PayloadAction<User>) => {
      return action.payload;
    },
    accessDenied: (state) => {
      if (state === null) return state;
      return { ...state, accessDenied: true };
    },
    apiFailure: (state) => {
      if (state === null) return state;
      return { ...state, apiFailure: true };
    },
    trialEnded: (state) => {
      if (state === null) return state;
      return { ...state, trialEnded: true };
    },
    userPermissionsChanged: (state, action: PayloadAction<User>) => {
      if (state === null) return state;
      return { ...state, ...action.payload, permissionsChanged: true };
    },
    clearUserProperties: (state) => {
      if (state === null) return state;

      const {
        accessDenied,
        apiFailure,
        permissionsChanged,
        trialEnded,
        ...user
      } = state;
      return user;
    },
    userSignedOut: () => {
      return null;
    },
  },
});

export const {
  storeUser,
  userSignedIn,
  accessDenied,
  apiFailure,
  trialEnded,
  userPermissionsChanged,
  clearUserProperties,
  userSignedOut,
} = userSlice.actions;

export default userSlice.reducer;
